import { useState } from 'react';
import {
  INITIAL_FORM_DATA,
  validatePhoneNumber,
  validateAccountField
} from '@/features/b2b/register/services/registrationService';

export const useRegistrationForm = () => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let filteredValue = value;

    // Handle phone number validation
    if (name === 'phone2' || name === 'mobileNo') {
      filteredValue = validatePhoneNumber(value, name);
    }

    // Handle account fields validation
    if (name === 'accountNumber' || name === 'sortCode') {
      const validatedValue = validateAccountField(value, name);
      if (validatedValue === null) {
        return; // Don't update if validation failed
      }
      filteredValue = validatedValue;
    }

    setFormData(prev => ({
      ...prev,
      [prev.step]: {
        ...prev[prev.step],
        [name]: type === 'checkbox' ? checked : filteredValue,
      },
    }));

    // Clear error when user starts typing
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleSelectChange = name => value => {
    setFormData(prev => ({
      ...prev,
      [prev.step]: {
        ...prev[prev.step],
        [name]: value,
      },
    }));
  };

  const scrollToTop = () => {
    const container = document.getElementById('register-scroll-container');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const nextStep = () => {
    setFormData(prev => ({
      ...prev,
      step: prev.step + 1,
    }));
    scrollToTop();
  };

  const prevStep = () => {
    if (formData.step > 1) {
      setFormData(prev => ({
        ...prev,
        step: prev.step - 1,
      }));
      scrollToTop();
    }
  };

  const getRequestData = () => {
    return { ...formData[1], ...formData[2], ...formData[3] };
  };

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    handleInputChange,
    handleSelectChange,
    nextStep,
    prevStep,
    getRequestData,
  };
};
